import React, { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen } from 'lucide-react';
import EditableText from '@/components/EditableText';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BooksLandingPage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/books-catalog`)
      .then((r) => setBooks(r.data || []))
      .catch(() => setBooks([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#FDF6EC] to-[#F5E9D3] py-16">
        <div className="max-w-6xl mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 text-[#B5813B] font-semibold uppercase tracking-[0.2em] text-sm mb-3">
              <BookOpen className="w-4 h-4" /> <EditableText as="span" id="books.hero.eyebrow">Bookstore</EditableText>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-[#1B4B5A]" style={{ fontFamily: 'Georgia, serif' }}>
              <EditableText as="span" id="books.hero.title">Books</EditableText>
            </h1>
            <p className="text-lg text-[#4A5568] mt-4 max-w-2xl mx-auto">
              <EditableText as="span" id="books.hero.subtitle">Explore the collection. Click any title to learn more and purchase.</EditableText>
            </p>
          </div>

          {loading ? (
            <div className="text-center py-20">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#1B4B5A] mx-auto"></div>
            </div>
          ) : books.length === 0 ? (
            <p className="text-center text-[#4A5568] py-20" data-testid="books-empty">No books available yet. Check back soon.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" data-testid="books-grid">
              {books.map((book) => (
                <Link
                  key={book.id}
                  to={`/books/${book.slug}`}
                  data-testid={`book-card-${book.slug}`}
                  className="group block"
                >
                  <div className="aspect-[3/4] rounded-xl overflow-hidden shadow-lg border-2 border-white group-hover:border-[#B5813B] transition-all bg-white">
                    {book.cover_image_url ? (
                      <img src={book.cover_image_url} alt={book.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-[#1B4B5A] text-white">
                        <BookOpen className="w-10 h-10 opacity-50" />
                      </div>
                    )}
                  </div>
                  <h3 className="mt-3 text-lg font-bold text-[#1B4B5A] leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
                    {book.title}
                  </h3>
                  {book.author && <p className="text-sm text-[#B5813B] mt-1">{book.author}</p>}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
